/* global
  trapFocus,
  removeTrapFocus,
  CartItems
*/
// 隐私政策弹出层弹窗板块
;(function () {
  const modal = document.getElementById('FreeShippingModal')
  if (!modal) return

  const open = () => {
    modal.hidden = false
    modal.setAttribute('aria-hidden', 'false')
    document.documentElement.style.overflow = 'hidden'
  }

  const close = () => {
    modal.hidden = true
    modal.setAttribute('aria-hidden', 'true')
    document.documentElement.style.overflow = ''
  }

  // 打开按钮（支持多个）
  document.addEventListener('click', e => {
    if (e.target.closest('.js-open-free-shipping')) {
      e.preventDefault()
      open()
      return
    }
    // 关闭：点遮罩或关闭按钮
    if (e.target.closest('[data-modal-close]')) {
      e.preventDefault()
      close()
    }
  })
})()
/**
 * 切换购物车推荐列表的显示状态
 * @param {Document} containerRoot - 容器根元素
 */
function toggleCartRecommendations(containerRoot = document) {
  const containers = containerRoot.querySelectorAll('.cart-recommendations-container')
  containers.forEach(container => {
    const hasItems =
      container.querySelector('.cart-recommendations-card-item') || container.querySelector('.splide__slide')
    if (hasItems) {
      container.classList.remove('is-empty')
    } else {
      container.classList.add('is-empty')
    }
  })
}

/**
 * 购物车抽屉组件
 */
class CartDrawer extends HTMLElement {
  constructor() {
    super()
    this.focusTrapTimeout = null

    this.onEscapeKeydown = evt => {
      if (!this.classList.contains('active')) return

      const isEscapeKey = evt.key === 'Escape' || evt.code === 'Escape'
      if (isEscapeKey) this.close()
    }

    document.addEventListener('keydown', this.onEscapeKeydown)
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this))
    this.setHeaderCartIconAccessibility()

    // 新增一个标志变量来判断是否是加购成功
    this.isAddSuccess = false
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onEscapeKeydown)
    if (this.focusTrapTimeout) window.clearTimeout(this.focusTrapTimeout)
  }

  getDialogContainer() {
    return (
      this.querySelector('#CartDrawer') ||
      this.querySelector('.drawer__inner[role="dialog"]') ||
      this.querySelector('.drawer__inner')
    )
  }

  getInitialFocusElement() {
    return this.querySelector('.cart-drawer__close') || this.getDialogContainer()
  }

  trapDrawerFocus() {
    const containerToTrapFocusOn = this.getDialogContainer()
    const focusElement = this.getInitialFocusElement()
    if (!containerToTrapFocusOn || !focusElement) return
    trapFocus(containerToTrapFocusOn, focusElement)
  }

  /**
   * 设置购物车图标可访问性
   */
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble')
    if (!cartLink) return

    // 如果在 /cart 页面，不绑定打开购物车抽屉的事件
    const isCartPage = window.location.pathname === (window.routes?.cart_url || '/cart')
    if (isCartPage) {
      return
    }

    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', event => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', event => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  /**
   * 打开购物车抽屉
   * @param {HTMLElement} triggeredBy - 触发事件的元素
   */
  open(triggeredBy) {
    // 如果在 /cart 页面，不允许打开购物车抽屉
    const isCartPage = window.location.pathname === (window.routes?.cart_url || '/cart')
    if (isCartPage) {
      return
    }

    // 如果是正常打开购物车（不是加购成功触发），隐藏成功消息
    if (!this.isAddSuccess) {
      this.hideAddSuccessMessage()
    }

    if (!this.isIOS()) {
      if (triggeredBy) this.setActiveElement(triggeredBy)
      else if (!this.activeElement && document.activeElement instanceof HTMLElement)
        this.setActiveElement(document.activeElement)
    }
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote)

    setTimeout(() => {
      this.classList.add('animate', 'active')

      document.body.classList.add('cart-drawer-open')
      document.documentElement.classList.add('cart-drawer-open')

      //- 如果有splide组件，则触发组件刷新
      const splideComponents = this.querySelectorAll('splide-slider')
      if (splideComponents.length > 0) {
        splideComponents.forEach(element => {
          element.slider?.refresh()
        })
      }
    })

    this.addEventListener(
      'transitionend',
      () => {
        this.trapDrawerFocus()
      },
      { once: true }
    )

    if (this.focusTrapTimeout) window.clearTimeout(this.focusTrapTimeout)
    this.focusTrapTimeout = window.setTimeout(() => {
      if (!this.classList.contains('active')) return
      this.trapDrawerFocus()
    }, 250)

    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.classList.remove('active')
    if (this.focusTrapTimeout) {
      window.clearTimeout(this.focusTrapTimeout)
      this.focusTrapTimeout = null
    }
    removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')
    document.body.classList.remove('cart-drawer-open')
    document.documentElement.classList.remove('cart-drawer-open')
  }

  // 显示加购成功消息
  showAddSuccessMessage() {
    const successMessage = this.querySelector('.cart-add-success')
    if (successMessage) {
      successMessage.style.display = 'flex' // 显示成功消息
      setTimeout(() => {
        successMessage.style.display = 'none'
      }, 3000) // 3秒后隐藏
    }
    this.isAddSuccess = false // 重置加购成功状态
  }

  // 隐藏加购成功消息
  hideAddSuccessMessage() {
    const successMessage = this.querySelector('.cart-add-success')
    if (successMessage) {
      successMessage.style.display = 'none'
    }
    this.isAddSuccess = false // 重置状态
  }

  // 显示加购失败消息
  showAddErrorMessage() {
    const errorMessage = this.querySelector('.cart-add-error')
    if (errorMessage) {
      errorMessage.style.display = 'flex' // 显示失败消息
      setTimeout(() => {
        errorMessage.style.display = 'none'
      }, 3000) // 3秒后隐藏
    }
    this.isAddSuccess = false // 重置加购失败状态
  }

  // 隐藏加购失败消息
  hideAddErrorMessage() {
    const successMessage = this.querySelector('.cart-add-success')
    if (successMessage) {
      successMessage.style.display = 'none'
    }
    this.isAddSuccess = false // 重置状态
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button')
    cartDrawerNote.setAttribute('aria-expanded', 'false')

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id)
    }

    cartDrawerNote.addEventListener('click', event => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
    })
  }

  /**
   * 渲染购物车抽屉内容
   * @param {Object} parsedState - 购物车抽屉内容
   */
  renderContents(parsedState) {
    // 如果在 /cart 页面，不打开购物车抽屉
    const isCartPage = window.location.pathname === (window.routes?.cart_url || '/cart')
    if (isCartPage) {
      return
    }

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty')
    this.productId = parsedState.id
    this.getSectionsToRender().forEach(section => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)

      if (!sectionElement) return
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
    })

    // 更新推荐产品容器（从 main-cart-items section 中提取）
    const mainCartItemsSection = parsedState.sections?.['main-cart-items']
    if (mainCartItemsSection) {
      const html = new DOMParser().parseFromString(mainCartItemsSection, 'text/html')
      const sourceRecommendations = html.querySelector('.cart-recommendations-container')
      if (sourceRecommendations) {
        // 更新购物车抽屉中的所有推荐产品容器
        const targetRecommendations = this.querySelectorAll('.cart-recommendations-container')
        targetRecommendations.forEach(target => {
          target.innerHTML = sourceRecommendations.innerHTML
        })
      }
    }

    toggleCartRecommendations(this)

    // renderContents 只在加购成功时被调用，设置加购成功标志
    this.isAddSuccess = true

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this))
      this.open()
      // 在打开购物车后显示加购成功消息
      this.showAddSuccessMessage()
    })
  }

  /**
   * 获取购物车抽屉的 section inner HTML
   * @param {string} html - 商品列表 HTML
   * @param {string} selector - 选择器
   * @returns {string} inner HTML
   */
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  /**
   * 获取购物车抽屉的 sections
   * @returns {Array} sections - 购物车抽屉的 sections
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ]
  }

  isIOS() {
    return (
      /iP(hone|od|ad)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    )
  }

  /**
   * 设置激活元素
   * @param {HTMLElement} element - 激活元素
   */
  setActiveElement(element) {
    if (this.isIOS()) return
    this.activeElement = element
  }
}

/**
 * 购物车抽屉商品列表组件
 */
class CartDrawerItems extends CartItems {
  /**
   * 获取购物车抽屉商品列表的 sections
   * @returns {Array} sections - 购物车抽屉商品列表的 sections
   */
  getSectionsToRender() {
    return [
      // 1) 抽屉商品列表（稳定：永远有 #CartDrawer-CartItems）
      {
        id: 'CartDrawer-CartItems',
        section: 'cart-drawer',
        selector: '#CartDrawer-CartItems'
      },

      // 1.5) 抽屉头部（包含标题数量），用于同步购物车数量
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__header'
      },

      // 2) 抽屉底部合计区（稳定：我们给它加了 id）
      {
        id: 'CartDrawer-Footer',
        section: 'cart-drawer',
        selector: '#CartDrawer-Footer'
      },

      // 3) 购物车 icon bubble
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },

      // 4) live region（如果你主题有这个 section）
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },

      // 5) main-cart-items section（用于更新推荐产品）
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.cart-recommendations-container'
      }
    ]
  }
}

// cart-drawer
if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer)
}

// cart-drawer-items
if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems)
}
